/* eslint-disable react/prop-types */ // TODO: add props
import { useState } from 'react';
import PT from 'prop-types';
import { Link } from 'react-router-dom';
import { Button } from 'edrolo-style-guide';
import CollabModal from '../CollabModal';
import { Activity } from 'core/components/Activity';
import s from './styles.scss';

export const ActivityTab = ({
  students,
  isTeacherView,
  collabModalOptions,
  activity,
  activityResponse = {},
  saveActivityResponse,
  onActivityResponseChange,
  readOnly,
  nextUrl,
  showExample,
  reviewMode,
  analyticsPayload = {},
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const { enable_collaborators = false } = activity || {};
  const { collaborators = [] } = activityResponse;

  const handleBlockResponseChange = (blockId, blockResponseData) => {
    const updatedActivityResponse = {
      ...activityResponse,
      block_responses: {
        ...activityResponse?.block_responses,
        [blockId]: blockResponseData,
      },
    };
    onActivityResponseChange(updatedActivityResponse);
  };

  return (
    <div className={s.activityTab}>
      {enable_collaborators && !isTeacherView && (
        <header>
          <div className={s.collaborators}>
            <Button onClick={() => setIsOpen(true)} small outline>
              Select Collaborators
            </Button>
            {!!collaborators?.length && !!students.length && (
              <p>
                <strong>Collaborators: </strong>
                {collaborators.map((c, i) => {
                  const student = students.find((s) => s.profile_id === c);
                  return (
                    <span key={student?.profile_id || i}>
                      {student?.display_name}
                      {i < collaborators.length - 1 && ', '}
                    </span>
                  );
                })}
              </p>
            )}
          </div>
          <div>
            {activityResponse?.has_collaborated_on_the_activity && (
              <p>
                <strong>
                  {
                    'A group response has been submitted and your name has been included as a collaborator'
                  }
                </strong>
              </p>
            )}
            <p>
              <strong>Note:</strong> only one person needs to submit a response
              for the group
            </p>
          </div>
          <CollabModal
            isOpen={isOpen}
            onClose={() => setIsOpen(false)}
            studentOptions={collabModalOptions}
            selectedStudentIds={collaborators}
            onSubmit={(updatedCollaborators) => {
              const updatedCollaboratorIds = updatedCollaborators.map(
                (c) => c.value
              );

              onActivityResponseChange({
                ...activityResponse,
                collaborators: updatedCollaboratorIds,
              });
              analytics?.track('collaborators saved', {
                ...analyticsPayload,
                number_of_collaborators: updatedCollaboratorIds.length,
              });
            }}
          />
        </header>
      )}

      <Activity
        activity={activity}
        activityResponse={activityResponse}
        onBlockResponseChange={handleBlockResponseChange}
        readOnly={readOnly}
        showExample={showExample}
        reviewMode={reviewMode}
      />
      <footer className={s.footer}>
        <Button
          onClick={() => {
            saveActivityResponse({
              ...activityResponse,
              ready_for_review: true,
            });
            analytics?.track('clicked submit activity', {
              activity_id: activity.id,
              ...analyticsPayload,
            });
          }}
          disabled={activityResponse?.ready_for_review}
        >
          {activityResponse?.ready_for_review ? 'Submitted' : 'Submit answer'}
        </Button>
        {nextUrl && (
          <Link to={nextUrl}>
            <Button>Continue</Button>
          </Link>
        )}
      </footer>
    </div>
  );
};

ActivityTab.propTypes = {
  collabModalOptions: PT.arrayOf(
    PT.shape({
      value: PT.number,
      label: PT.string,
    })
  ),
  students: PT.arrayOf(
    PT.shape({
      profile_id: PT.number,
      display_name: PT.string,
    })
  ),
  activity: PT.object,
  nextUrl: PT.string,
  activityResponse: PT.object,
  onActivityResponseChange: PT.func,
  readOnly: PT.bool,
  showExample: PT.bool,
  reviewMode: PT.bool,
  isTeacherView: PT.bool,
};
